import { createSlice } from '@reduxjs/toolkit';
import { PortfolioModel } from './Portfolio.types';

const initialState = {
  expandedProjects: [] as string[],
  portfolios: [] as PortfolioModel[],
};

export const portfolioReducer = createSlice({
  name: 'portfolio',
  initialState,
  reducers: {},
});

export const {} = portfolioReducer.actions;

export default portfolioReducer.reducer;
